var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "omegaup-overlay-popup",
    {
      on: {
        dismiss: function($event) {
          return _vm.onCloseModal(_vm.currentView)
        }
      }
    },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "form",
          {
            staticClass: "h-auto w-auto",
            attrs: { "data-promotion-popup": "" },
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "container-fluid d-flex align-items-start flex-column"
              },
              [
                _vm.currentView === _vm.AvailableViews.Content
                  ? [
                      _vm._t(
                        "popup-content",
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "h4 font-weight-bold pb-4 text-center w-100"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.solved
                                      ? _vm.T.qualityFormCongrats
                                      : _vm.T.qualityFormRateBeforeAc
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c("div", { staticClass: "form-group w-100" }, [
                            _c("label", { staticClass: "w-100" }, [
                              _vm._v(_vm._s(_vm.T.qualityFormDifficulty))
                            ]),
                            _c(
                              "div",
                              { staticClass: "container-fluid" },
                              _vm._l(_vm.difficultyLevels, function(
                                difficultyLevel
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: difficultyLevel.id,
                                    staticClass: "form-check form-check-inline"
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-check-label" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.difficulty,
                                              expression: "difficulty"
                                            }
                                          ],
                                          attrs: {
                                            "data-dificulty-radio-button": "",
                                            type: "radio"
                                          },
                                          domProps: {
                                            value: difficultyLevel.id,
                                            checked: _vm._q(
                                              _vm.difficulty,
                                              difficultyLevel.id
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.difficulty =
                                                difficultyLevel.id
                                            }
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              difficultyLevel.description
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ]),
                          _c("div", { staticClass: "w-100 mb-3" }, [
                            _c("label", { staticClass: "mb-2 w-100" }, [
                              _vm._v(_vm._s(_vm.T.qualityFormQuality))
                            ]),
                            _c(
                              "div",
                              { staticClass: "container-fluid" },
                              _vm._l(_vm.qualityLevels, function(qualityLevel) {
                                return _c(
                                  "div",
                                  {
                                    key: qualityLevel.id,
                                    staticClass: "form-check form-check-inline"
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-check-label" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.quality,
                                              expression: "quality"
                                            }
                                          ],
                                          attrs: { type: "radio" },
                                          domProps: {
                                            value: qualityLevel.id,
                                            checked: _vm._q(
                                              _vm.quality,
                                              qualityLevel.id
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.quality = qualityLevel.id
                                            }
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(qualityLevel.description) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ]),
                          _c("div", { staticClass: "text-right w-100" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "col-md-4 mr-2 mb-1 btn btn-primary",
                                attrs: {
                                  "data-submit-feedback-button": "",
                                  type: "submit",
                                  disabled: !_vm.quality && !_vm.difficulty
                                },
                                on: { click: _vm.onSubmit }
                              },
                              [_vm._v(" " + _vm._s(_vm.T.wordsSend) + " ")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "col-md-4 mb-1 btn btn-secondary",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.onHide(true)
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(_vm.T.wordsCancel) + " ")]
                            )
                          ])
                        ],
                        { onSubmit: _vm.onSubmit, onHide: _vm.onHide }
                      )
                    ]
                  : _vm._e(),
                _vm.currentView === _vm.AvailableViews.Thanks
                  ? [
                      _c("div", { staticClass: "w-100 h-100 h3 text-center" }, [
                        _vm._v(
                          " " + _vm._s(_vm.T.qualityFormThanksForReview) + " "
                        )
                      ])
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }